import React from 'react';
import { APP_URLS } from '../../utils/appUrls';

const SubmitOhiDescription = () => (
  <>
    <p>
      To update your other non-VA health insurance information, you’ll need to
      submit a CHAMPVA Other Health Insurance Certification (VA Form 10-7959c).
    </p>
    <va-link-action
      type="primary"
      href={APP_URLS.ohi}
      text="Submit other health insurance information for CHAMPVA online"
    />
    <p>
      <strong>Note:</strong> If you also need to update your supporting
      documents, go back and select <strong>Both types of information</strong>.
    </p>
  </>
);

export default SubmitOhiDescription;
